import { render, staticRenderFns } from "./AboutMenu.vue?vue&type=template&id=114a63fc"
import script from "./AboutMenu.vue?vue&type=script&lang=ts"
export * from "./AboutMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports